<template>
  <div>
    <app-panel
      :isExpand="alarmDetailVisible"
      title="报警信息详情"
      @cancel="handleClosePanel"
    >
      <!-- <el-dialog title="报警信息详情"
               v-dialogDrag
               :visible.sync="alarmDetailVisible"
               width="700px"
               class="alarm-detial-box"> -->
      <el-scrollbar style="height: 100%">
        <div class="ioc-detail">
          <div
            class="ioc-group"
            v-if="
              currentAlarm.subSystem != '12' &&
              (currentAlarm.alarmSnapUrl || currentAlarm.picUrl)
            "
          >
            <div class="el-row ioc-group__item" span="24">
              <div class="ioc-group__header">
                <!---->
                <h3 class="ioc-group__title">
                  {{ $t("historyAlarm.title.SnapshotPreview") }}
                </h3>
              </div>
              <div
                class="ioc-detail__image"
                style="width: 100%; margin: 16px 10px; text-align: center"
              >
                <template
                  v-if="currentAlarm.alarmSnapUrl || currentAlarm.picUrl"
                >
                  <!-- 黑名单 -->
                  <div
                    v-if="
                      currentAlarm.alarmType == '50102' &&
                      currentAlarm.subSystem !== '9'
                    "
                    key="alarmPicture"
                    class="flex-between black-list-pic-area"
                  >
                    <div class="black-list-pic">
                      <span class="pic-title">抓拍人员</span>
                      <img
                        class="lookPhoto"
                        v-if="currentAlarm.alarmSnapUrl || currentAlarm.picUrl"
                        :src="
                          imgPath(
                            currentAlarm.alarmSnapUrl || currentAlarm.picUrl
                          )
                        "
                        alt
                        @click="showViewer"
                        onerror="this.src='/images/theme/newDark/default.png'"
                      />
                    </div>
                    <div class="black-list-pic">
                      <span class="pic-title">黑名单人员</span>
                      <img
                        class="lookPhoto"
                        v-if="currentAlarm.picFileId"
                        :src="imgPath(currentAlarm.picFileId)"
                        alt
                        @click="showViewer"
                        onerror="this.src='/images/theme/newDark/default.png'"
                      />
                    </div>
                    <span class="similarity-text"
                      >{{ Number(currentAlarm.similarity) / 100 }} %</span
                    >
                  </div>
                  <!-- 手动告警 -->
                  <el-carousel
                    style="height: 180px; overflow: hidden"
                    v-else-if="currentAlarm.subSystem === '9'"
                  >
                    <el-carousel-item
                      v-for="item in (currentAlarm.picUrl || '').split(',')"
                      :key="item"
                    >
                      <img
                        class="lookPhoto"
                        :src="imgPath(item)"
                        style="width: 300px; height: 180px"
                        alt
                        @click="showViewer"
                        onerror="this.src='/images/theme/newDark/default.png'"
                      />
                    </el-carousel-item>
                  </el-carousel>
                  <!-- 抓拍 -->
                  <el-carousel style="height: 180px; overflow: hidden" v-else>
                    <el-carousel-item
                      v-for="item in (currentAlarm.alarmSnapUrl || '').split(
                        ','
                      )"
                      :key="item"
                    >
                      <img
                        class="lookPhoto"
                        :src="imgPath(item)"
                        style="width: 300px; height: 180px"
                        alt
                        @click="showViewer"
                        onerror="this.src='/images/theme/newDark/default.png'"
                      />
                    </el-carousel-item>
                  </el-carousel>
                </template>
                <!-- <template v-else>
                  <img
                    style="height: 120px; width: 100%"
                    :src="`/images/theme/newDark/no-img.jpg`"
                  />
                </template> -->
              </div>
            </div>
          </div>
          <!-- 告警详情 -->
          <div class="ioc-group">
            <div class="el-row ioc-group__item" span="24">
              <div class="ioc-group__header">
                <h3 class="ioc-group__title">
                  {{ currentAlarm.subSystem !== "12" ? "" : "一键求救-"
                  }}{{ $t("historyAlarm.title.alarmDetail") }}
                </h3>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.title.alarmName")
                  }}</span>
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmName
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >{{ $t("historyAlarm.title.alarmType") }} ：
                  </span>
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmTypeLabel
                  }}</span>
                </div>
              </div>
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.alarmType == '80101'"
              >
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >限速 ：
                  </span>
                  <!---->
                  <span class="ioc-detail__content pl5"
                    >{{ currentAlarm.overSpeed }}km/h</span
                  >
                  <!-- <span class="ioc-detail__content alarm-name"
                      :title="alarmName(currentAlarm.alarmType)">{{ alarmName(currentAlarm.alarmType) }}</span> -->
                </div>
              </div>
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.alarmType == '80101'"
              >
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >当前车速 ：
                  </span>
                  <!---->
                  <span class="ioc-detail__content pl5"
                    >{{ currentAlarm.speed }}km/h</span
                  >
                  <!-- <span class="ioc-detail__content alarm-name"
                      :title="alarmName(currentAlarm.alarmType)">{{ alarmName(currentAlarm.alarmType) }}</span> -->
                </div>
              </div>
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.alarmType == '80101'"
              >
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >上浮速度 ：
                  </span>
                  <!---->
                  <span class="ioc-detail__content pl5"
                    >{{ currentAlarm.floatSpeed }}km/h</span
                  >
                  <!-- <span class="ioc-detail__content alarm-name"
                      :title="alarmName(currentAlarm.alarmType)">{{ alarmName(currentAlarm.alarmType) }}</span> -->
                </div>
              </div>
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.alarmType == '80101'"
              >
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >车牌 ：
                  </span>
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.plateNo
                  }}</span>
                  <!-- <span class="ioc-detail__content alarm-name"
                      :title="alarmName(currentAlarm.alarmType)">{{ alarmName(currentAlarm.alarmType) }}</span> -->
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >{{ $t("historyAlarm.title.alarmLevel") }} ：</span
                  >
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmLevel | dic("SENU017")
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >{{ $t("historyAlarm.title.alarmTime") }} ：</span
                  >
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmTime | moment
                  }}</span>
                </div>
              </div>
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.subSystem != '14'"
              >
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >设备组名称 ：</span
                  >
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.deviceWorkGroupName
                  }}</span>
                </div>
              </div>
              <!-- 8--安防  12- 一键求救  14- 可燃气体  16--广播-->
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="
                  currentAlarm.subSystem != '12' &&
                  currentAlarm.subSystem != '13' &&
                  currentAlarm.subSystem != '14' &&
                  currentAlarm.subSystem != '16' &&
                  currentAlarm.subSystem != '9' &&
                  currentAlarm.subSystem != '8'
                "
              >
                <div class="ioc-detail__box mt10" style="display: flex">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >录像回放 ：</span
                  >
                  <span class="ioc-detail__content pl5">
                    <!-- <span
                      v-if="
                        !currentAlarm.playBackUrl && currentAlarm.subSystem != 5
                      "
                      >{{ $t("historyAlarm.label.no") }}</span
                    > -->
                    <span>
                      <img
                        @click="viewVideo()"
                        style="cursor: pointer"
                        src="@src/common/assets/images/video.png"
                        alt=""
                      />
                    </span>
                  </span>
                </div>
              </div>
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-24"
                v-if="
                  uploadVideoShow &&
                  currentAlarm.subSystem != '12' &&
                  currentAlarm.subSystem != '14'
                "
              >
                <div class="ioc-detail__box mt10" style="display: flex">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >上传视频 ：
                  </span>
                  <span class="ioc-detail__content pl5">
                    <span v-if="!currentAlarm.videoUrl">{{
                      $t("historyAlarm.label.no")
                    }}</span>
                    <span v-else style="display: flex">
                      <div
                        class="file-item"
                        v-for="(item, index) in currentAlarm.videoUrl.split(
                          ','
                        )"
                        :key="index"
                      >
                        <video
                          style="object-fit: fill"
                          class="file-comp"
                          :src="$utils.Bus.imgPath(item)"
                        ></video>
                        <div
                          style="cursor: pointer"
                          class="play-icon iconfont-lunan icon-lunan-qidong"
                          @click="handleShowVideos(item)"
                        ></div>
                      </div>
                    </span>
                  </span>
                </div>
              </div>
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-show="currentAlarm.reportPersonName"
              >
                <div class="ioc-detail__box">
                  <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.label.reportTo")
                  }}</span>
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.reportPersonName
                  }}</span>
                </div>
              </div>
              <!-- 有毒有害气体 -->
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.subSystem == '14'"
              >
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >监控点名称 ：</span
                  >
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.deviceName
                  }}</span>
                </div>
              </div>
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.subSystem == '14'"
              >
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >探测器名称 ：</span
                  >
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.parentDeviceName
                  }}</span>
                </div>
              </div>
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.subSystem == '14'"
              >
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >浓度值 ：</span
                  >
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.concentration
                  }}</span>
                </div>
              </div>
              <!-- 一键求救 -->
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.subSystem == '12'"
              >
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >故障类型 ：</span
                  >
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmSubType | dic("SENU103")
                  }}</span>
                </div>
              </div>
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.subSystem == '12'"
              >
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >一键求救设备 ：</span
                  >
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.deviceName
                  }}</span>
                </div>
              </div>
              <div
                class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.subSystem == '12'"
              >
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >设备位置 ：</span
                  >
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.groupName
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.label.warnDesc")
                  }}</span>
                  <span class="ioc-detail__content handle-desc pl5">{{
                    currentAlarm.desc
                  }}</span>
                </div>
              </div>
              <!---->
            </div>
          </div>
          <!-- 告警处理 -->
          <div class="ioc-group">
            <div class="el-row ioc-group__item" span="24">
              <div class="ioc-group__header">
                <h3 class="ioc-group__title">
                  {{ $t("historyAlarm.title.dealWith") }}
                </h3>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.title.Processingpers")
                  }}</span>
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.modifierName || currentAlarm.modifier
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.title.ProcessingDes")
                  }}</span>
                  <span class="ioc-detail__content pl5 handle-desc">{{
                    currentAlarm.processDesc
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right"
                    >处理时间 ：</span
                  >
                  <span class="ioc-detail__content pl5 handle-desc">{{
                    currentAlarm.modifyTime | moment
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="handleClosePanel"> 取消 </el-button>
      </div>
    </app-panel>
    <!-- </el-dialog> -->
    <viewer
      @inited="inited"
      :images="viewerPhotos"
      class="viewer"
      style="z-index: 99999"
      ref="viewer"
    >
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
    <fastLinkDeviceList
      ref="fastLinkDeviceList"
      :deviceList="videoDeviceArr"
      @playVideo="playVideo"
    ></fastLinkDeviceList>

    <!-- 手动上传视频 -->
    <div>
      <el-dialog
        :before-close="handleCloseVideo"
        :visible.sync="dialogShowVideo"
        append-to-body
        title="上传视频"
        width="600px"
      >
        <div style="width: 100%; height: 380px">
          <video
            autoplay
            muted
            style="width: 100%; height: 100%; object-fit: fill"
            controls="controls"
            :src="$utils.Bus.downFile(dialogShowVideoSrc)"
          ></video>
        </div>
      </el-dialog>
    </div>
    <!--展示资源大图-->
    <el-dialog
      :title="$t('historyAlarm.title.resourcesDetail')"
      :visible.sync="resourceAlarmDailogShow"
      width="540px"
      v-dialogDrag
      :close-on-click-modal="false"
      :before-close="resourceClose"
    >
      <resource-show-alarm
        ref="resourceAlarmDialog"
        :resourceUrl="currentResource"
        :alarmInfo="currentAlarm"
      ></resource-show-alarm>
    </el-dialog>
  </div>
</template>
<script>
import appPanel from "@src/components/business/app-panel/index.vue";
import { API } from "../api";
import { Dates, Bus, Dic, Base, Cache } from "$utils";
import fastLinkDeviceList from "@src/components/business/app-alarm/fastLinkDeviceList.vue";
import resourceShowAlarm from "@src/components/business/app-resource-show-alarm";
export default {
  components: {
    fastLinkDeviceList,
    resourceShowAlarm,
    appPanel,
  },
  data() {
    return {
      dialogShowVideoSrc: "",
      dialogShowVideo: false,
      alarmId: "",
      alarmDetailVisible: false,
      uploadVideoShow: true,
      alarmInfo: {},
      currentAlarm: {},
      viewerInstance: null,
      viewerPhotos: [],
      deviceArr: [],
      videoDeviceArr: [],
      currentResource: [],
      resourceAlarmDailogShow: false,
    };
  },
  watch: {},
  methods: {
    handleClosePanel() {
      this.alarmDetailVisible = false;
      this.currentAlarm = {};
    },
    open(info) {
      this.alarmInfo = info;
      this.alarmId = info.alarmId;
      this.getAlarmDetail();
      this.alarmDetailVisible = true;
    },
    getAlarmDetail() {
      console.log(this.alarmInfo);
      if (
        this.alarmInfo.subSystem == 9 ||
        this.alarmInfo.subSystem == 11
        // this.alarmInfo.alarmType == 50101 ||
        // this.alarmInfo.alarmType == 50102 ||
        // this.alarmInfo.alarmType == 50103
      ) {
        this.uploadVideoShow = true;
      } else {
        this.uploadVideoShow = false;
      }
      const params = {
        alarmId: this.alarmId,
      };
      this.$fetch(API.alarm.queryAlarmDetail, params).then((res) => {
        if (res && res.success) {
          this.currentAlarm = res.returnObj;
          // if (this.currentAlarm.similarity >= 1) {
          //   this.currentAlarm.similarity = 100;
          // } else {
          //   this.currentAlarm.similarity = (
          //     this.currentAlarm.similarity * 100
          //   ).toFixed(2);
          // }
          this.currentAlarm.pictureList =
            this.currentAlarm.filePicSourceLists &&
            this.currentAlarm.filePicSourceLists.length &&
            this.currentAlarm.filePicSourceLists.filter((item) => {
              if (item.picResourceType !== 2) {
                return {
                  resourceCode: item.resourceCode,
                  picResourceType: item.picResourceType,
                };
              }
            });
          // 手动告警上传视频
          this.currentAlarm.manuaAlarmPicList =
            this.currentAlarm.filePicSourceLists.filter((item) => {
              if (item.picResourceType == 2) {
                return {
                  resourceCode: item.resourceCode,
                  picResourceType: item.picResourceType,
                  resourceName: item.resourceName,
                };
              }
            });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    imgPath(item = "") {
      return item ? Bus.imgPath(item) : "";
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(e) {
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    // 查看录像
    viewVideo() {
      console.log(this.currentAlarm);
      if (!this.currentAlarm.deviceName) {
        this.$message.error(this.$t("historyAlarm.message.noDeviceInfor"));
        return;
      }
      if (!this.currentAlarm.startTime && !this.currentAlarm.endTime) {
        this.$message.error(this.$t("historyAlarm.message.noDevicePlan"));
        return;
      }
      this.getFastLinkDev();
    },
    // 获取联动设备
    getFastLinkDev() {
      this.deviceArr = [];
      this.videoDeviceArr = [];
      let currentDevice = {
        deviceName: this.currentAlarm.deviceName,
        thirdDeviceId: this.currentAlarm.thirdAlarmDevId,
      };
      this.deviceArr.push(currentDevice);
      this.videoDeviceArr.push(currentDevice);
      if (this.deviceArr.length == 1 || this.videoDeviceArr.length == 1) {
        this.playVideo("back", this.currentAlarm);
      } else {
        this.showFastLinkDeviceList(this.videoDeviceArr);
      }
    },
    playVideo(type, item) {
      const startTime = item.startTime;
      const endTime = item.endTime;
      this.$app.AppInstance.handleMiniPlay({
        playType: type,
        playTitle: item.deviceName || this.currentAlarm.deviceName, //摄像机名称
        playId: item.thirdDeviceId || this.currentAlarm.thirdAlarmDevId, //摄像机id
        startTime: startTime || new Date().getTime() - 60 * 1000, //如果没有时间默认最新一分钟
        endTime: endTime || new Date().getTime(),
      });
    },
    // 展示联动设备列表
    showFastLinkDeviceList(list) {
      this.fastLinkDevice = list;
      this.$refs.fastLinkDeviceList.open("back");
    },
    // 查看上传视频
    handleShowVideos(src) {
      this.dialogShowVideoSrc = src;
      this.dialogShowVideo = true;
    },
    handleCloseVideo() {
      this.dialogShowVideo = false;
      this.dialogShowVideoSrc = "";
    },
    // 显示资源大图
    enlargeResource(item) {
      this.currentResource = item;
      this.resourceAlarmDailogShow = true;
    },
    resourceClose() {
      if (this.$refs.resourceAlarmDialog) {
        this.$refs.resourceAlarmDialog.stopVideo();
      }
      this.resourceAlarmDailogShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.ioc-detail {
  // padding: 20px 50px;
  .ioc-group {
    // @include set_theme_color(background-color, blur-color);
    padding: 10px;
    .el-col {
      margin-bottom: 12px;
    }
    .ioc-group__title {
      font-size: 15px;
      // color: #e8eaee;
      margin-bottom: 5px;
      border-left: 5px solid #407aee;
      padding-left: 10px;
    }
  }
  .file-item {
    margin-right: 5px;
    background-color: #ffffff;
    position: relative;
    .play-icon {
      position: absolute;
      top: 1px;
      left: 30px;
      font-size: 22px;
      &:hover {
        font-size: 25px;
      }
    }
  }
  .file-item,
  .file-comp {
    height: 88px;
    width: 88px;
    line-height: 88px;

    &:nth-child(3) {
      margin-right: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.black-list-pic {
  width: 49% !important;
  height: 210px !important;
  position: relative;
  cursor: pointer;

  .pic-title {
    position: absolute;
    left: 0;
    top: 0;
    padding: 4px 10px;
    background-color: #4a6ac7cc;
    border-radius: 0 0 5px 0;
    color: #fff;
    z-index: 1;
  }
  .lookPhoto {
    height: 100%;
    width: 100%;
  }
}

.alarm-detial-box {
  .ioc-detail {
    .ioc-group {
      @include set_theme_color(background-color, blur-color);
      opacity: 0.8;
      padding: 0 10px;
      .ioc-group__title {
        margin-bottom: 5px;
      }
      .ioc-detail__image {
        width: 100%;
        max-height: 300px;
        overflow: hidden;

        .black-list-pic-area {
          position: relative;
          .similarity-text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 50px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            border-radius: 50%;
            background-color: #4a6ac7;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>